import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { HttpService } from 'src/app/core/services/http.service';
import { IRequiredAction, IRequiredActionListResponse, RequiredActionOwnerType, RequiredActionState } from '../models/required-action.models';

@Injectable({ providedIn: 'root' })
export class RequiredActionsService {
    private readonly httpService = inject(HttpService);
    private readonly apiService = inject(ApiService);

    getRequiredActions(query = ''): Observable<IRequiredAction[]> {
        const url = this.apiService.pathUrl.requiredActions(query);
        return this.httpService.get$<IRequiredActionListResponse>(url).pipe(map(response => response.value ?? []));
    }

    getOpenRequiredActionsForOwner(ownerType: RequiredActionOwnerType, ownerId: string): Observable<IRequiredAction[]> {
        const filter =
            `$filter=ownerType eq '${ownerType}' and ownerId eq ${ownerId} and state eq '${RequiredActionState.Open}'` +
            `&$orderby=createdAt desc`;
        return this.getRequiredActions(`?${filter}`);
    }

    checkStatus(id: string): Observable<IRequiredAction> {
        return this.httpService.post$<IRequiredAction>(this.apiService.pathUrl.requiredActionCheckStatus(id), {}, new HttpParams());
    }
}
